module.exports = __webpack_public_path__ + "static/media/cover-1.458616ef.png";